import { render, staticRenderFns } from "./Nanxin.vue?vue&type=template&id=6386b156&scoped=true"
import script from "./Nanxin.vue?vue&type=script&lang=js"
export * from "./Nanxin.vue?vue&type=script&lang=js"
import style0 from "./Nanxin.vue?vue&type=style&index=0&id=6386b156&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6386b156",
  null
  
)

export default component.exports